import { render } from "./PastReports.vue?vue&type=template&id=a55cd710"
import script from "./PastReports.vue?vue&type=script&lang=js"
export * from "./PastReports.vue?vue&type=script&lang=js"

import "./PastReports.vue?vue&type=style&index=0&id=a55cd710&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__